"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseNostrLink = exports.tryParseNostrLink = exports.validateNostrLink = void 0;
const shared_1 = require("@snort/shared");
const _1 = require(".");
function validateNostrLink(link) {
    try {
        const parsedLink = parseNostrLink(link);
        if (!parsedLink) {
            return false;
        }
        if (parsedLink.type === _1.NostrPrefix.PublicKey || parsedLink.type === _1.NostrPrefix.Note) {
            return parsedLink.id.length === 64;
        }
        return true;
    }
    catch {
        return false;
    }
}
exports.validateNostrLink = validateNostrLink;
function tryParseNostrLink(link, prefixHint) {
    try {
        return parseNostrLink(link, prefixHint);
    }
    catch {
        return undefined;
    }
}
exports.tryParseNostrLink = tryParseNostrLink;
function parseNostrLink(link, prefixHint) {
    const entity = link.startsWith("web+nostr:") || link.startsWith("nostr:") ? link.split(":")[1] : link;
    const isPrefix = (prefix) => {
        return entity.startsWith(prefix);
    };
    if (isPrefix(_1.NostrPrefix.PublicKey)) {
        const id = (0, shared_1.bech32ToHex)(entity);
        if (id.length !== 64)
            throw new Error("Invalid nostr link, must contain 32 byte id");
        return {
            type: _1.NostrPrefix.PublicKey,
            id: id,
            encode: () => (0, shared_1.hexToBech32)(_1.NostrPrefix.PublicKey, id),
        };
    }
    else if (isPrefix(_1.NostrPrefix.Note)) {
        const id = (0, shared_1.bech32ToHex)(entity);
        if (id.length !== 64)
            throw new Error("Invalid nostr link, must contain 32 byte id");
        return {
            type: _1.NostrPrefix.Note,
            id: id,
            encode: () => (0, shared_1.hexToBech32)(_1.NostrPrefix.Note, id),
        };
    }
    else if (isPrefix(_1.NostrPrefix.Profile) || isPrefix(_1.NostrPrefix.Event) || isPrefix(_1.NostrPrefix.Address)) {
        const decoded = (0, _1.decodeTLV)(entity);
        const id = decoded.find(a => a.type === _1.TLVEntryType.Special)?.value;
        const relays = decoded.filter(a => a.type === _1.TLVEntryType.Relay).map(a => a.value);
        const author = decoded.find(a => a.type === _1.TLVEntryType.Author)?.value;
        const kind = decoded.find(a => a.type === _1.TLVEntryType.Kind)?.value;
        const encode = () => {
            return entity; // return original
        };
        if (isPrefix(_1.NostrPrefix.Profile)) {
            if (id.length !== 64)
                throw new Error("Invalid nostr link, must contain 32 byte id");
            return {
                type: _1.NostrPrefix.Profile,
                id,
                relays,
                kind,
                author,
                encode,
            };
        }
        else if (isPrefix(_1.NostrPrefix.Event)) {
            if (id.length !== 64)
                throw new Error("Invalid nostr link, must contain 32 byte id");
            return {
                type: _1.NostrPrefix.Event,
                id,
                relays,
                kind,
                author,
                encode,
            };
        }
        else if (isPrefix(_1.NostrPrefix.Address)) {
            return {
                type: _1.NostrPrefix.Address,
                id,
                relays,
                kind,
                author,
                encode,
            };
        }
    }
    else if (prefixHint) {
        return {
            type: prefixHint,
            id: link,
            encode: () => (0, shared_1.hexToBech32)(prefixHint, link),
        };
    }
    throw new Error("Invalid nostr link");
}
exports.parseNostrLink = parseNostrLink;
//# sourceMappingURL=data:application/json;base64,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